var $93f58c8f9f327a34$exports = {};
const $93f58c8f9f327a34$var$Configuration = {
    env: "production",
    sentryOrganizationId: "o4505133335904256",
    sentryProjectId: "4505286157729792",
    sentryKey: "558356d795f64c16a85cce356d98018c",
    sentryEnvironment: "production",
    sentryReleaseVersion: "a1191f6e7b94711af896fcbf0a0230cca970f7b6",
    plaidEnv: "production",
    plaidKey: "3d8ae5f373153608c9d3ad43fe88db",
    stripePublishableKey: "pk_live_ImPWqYGkbMfjwg22MiAmB6u4",
    amplitudeApiKey: "64ad70c116577a9a45ee51e6e36ff9d3",
    statuspageEmbedCode: "8mxj6zhmjmzp",
    newRelicAccountId: "1295351",
    newRelicLicenseKey: "f80caba954",
    newRelicApplicationId: "784027700",
    googleMapsKey: `&key=${"AIzaSyC70wIphqbjFg2gjPjkVGEpwym3QTKxSb4"}`,
    googleRecaptchaSiteKey: "6LfOL9gZAAAAADa1ZTyoPjOfwV9pQRXEMhAb9xRM",
    smartlookProjectKey: "6bc99ac84817ca8b3bc79b0ff316cd1d8d0af24a",
    apiUrl: "https://api.hint.com",
    apiVersion: "20230928193630",
    intercomAppId: "nt0e3shp",
    release: "a1191f6e7b94711af896fcbf0a0230cca970f7b6"
};
$93f58c8f9f327a34$exports = $93f58c8f9f327a34$var$Configuration;


window.CONFIGURATION = $93f58c8f9f327a34$exports;


//# sourceMappingURL=index.a67b660f.js.map
